import * as React from 'react';

import { DateRangePicker } from '@lightspeed/cirrus-datepicker';
import { Box } from '@lightspeed/flame/Core';

import { formatDateForMTDReport } from './utils';

const translations = {
  START_DATE_NOT_DEFINED: 'The start date is not defined',
  END_DATE_NOT_DEFINED: 'The end date is not defined',
  START_DATE_FORMAT_NOT_VALID: 'The start date is not valid',
  END_DATE_FORMAT_NOT_VALID: 'The end date is not valid',
  START_DATE_MUST_BE_BEFORE_END_DATE: 'The start date should be before the end date',
  END_DATE_MUST_BE_AFTER_START_DATE: 'The end date should be after the start date',
  START_DATE_NOT_WITHIN_RANGE: 'The start date is not within the accepted range',
  END_DATE_NOT_WITHIN_RANGE: 'The end date is not within the accepted range',
  APPLY: 'Apply',
  DAY_TITLE_FREE: (date: any) => `Choose: ${date}`,
  DAY_TITLE_SELECTED: (date: any) => `Selected. ${date}`,
  START_DATE_INPUT_PLACEHOLDER: 'dd/MM/yyyy',
  END_DATE_INPUT_PLACEHOLDER: 'dd/MM/yyyy',
};

interface ReportDatePickerProps {
  handleDates: (dates: string[]) => void;
}
interface IDates {
  startDate: Date;
  endDate: Date;
}
const ReportDatePicker: React.FC<ReportDatePickerProps> = ({ handleDates }) => {
  const endDate: Date = new Date();
  const startDate: Date = new Date();

  // TODO confirm the most used range
  // Change it so that it is 7 days in the past.
  const pastDate = endDate.getDate() - 7;
  startDate.setDate(pastDate);

  const [dates, setDates] = React.useState<IDates>({
    startDate,
    endDate,
  });

  React.useEffect(() => {
    const reportDates = Object.values(dates).map((date) => formatDateForMTDReport(date));
    handleDates(reportDates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates]);

  return (
    <Box className="mtd-date-picker">
      <DateRangePicker
        startDate={dates.startDate}
        endDate={dates.endDate}
        dateFormat="dd/MM/yyyy"
        translations={translations}
        onSubmit={(dates) => {
          setDates(dates);
        }}
      />
    </Box>
  );
};

export { ReportDatePicker };
